import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const apisListStyles = css`
    > .sds-card.sds-container {
        height: 100%;
        margin-bottom: 60px;
    }
`;

export const searchContainerStyle = css`
    > .sds-card-header {
        padding: ${Spacing.MD}px ${Spacing.XS}px;
    }
`;

export const VirtualizedContainer = styled.div`
    height: 100%;
`;
